export default __webpack_public_path__ + "static/media/mobile.7eaa2f39.svg";